/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\section.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


export const ADD_SECTION = 'ADD_SECTION';
export const REMOVE_SECTION = 'REMOVE_SECTION';
export const REDIRECT_TO_SECTION = 'REDIRECT_TO_SECTION';


export function setSection(section) {
  // TODO: test if the the
  return {
    type: ADD_SECTION,
    section,
    s_id,
    isaNav
  };
}


// we have only one section
export function removeSection() {
  return {
    type: REMOVE_SECTION,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/section.js